import { render, staticRenderFns } from "./RejectEvaluationsModalV2.vue?vue&type=template&id=c00634de&scoped=true"
import script from "./RejectEvaluationsModalV2.vue?vue&type=script&lang=js"
export * from "./RejectEvaluationsModalV2.vue?vue&type=script&lang=js"
import style0 from "./RejectEvaluationsModalV2.vue?vue&type=style&index=0&id=c00634de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00634de",
  null
  
)

export default component.exports